import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {ImageResizeOptions, WowImage} from '@wix/wix-ui-tpa/cssVars'
import classNames from 'classnames'
import React from 'react'
import {getSeo} from '../../../../../commons/selectors/environment'
import {useAppSelector} from '../../hooks/runtime'
import {getEvent} from '../../selectors/event'
import s from './event-image.scss'
import {classes} from './event-image.st.css'
import {EventImageProps} from './interfaces'

export const EventImage = ({containerRef, className, doubleHeight}: EventImageProps) => {
  const event = useAppSelector(getEvent)
  const seo = useAppSelector(getSeo)

  return (
    <div className={classNames(s.outerContainer, className)} ref={containerRef}>
      <div className={classNames(s.imageContainer, s.sizing, {[s.double]: doubleHeight})} data-hook={DH.eventImage}>
        {[
          {visibilityClass: classes.fitImage, resize: ImageResizeOptions.contain},
          {visibilityClass: classes.coverImage, resize: ImageResizeOptions.cover},
        ].map(({visibilityClass, resize}) => (
          <WowImage
            key={resize}
            className={classNames(classes.image, visibilityClass)}
            sourceWidth={event.mainImage.width}
            sourceHeight={event.mainImage.height}
            src={event.mainImage.id}
            alt={event.title}
            focalPoint={{x: 50, y: 50}}
            resize={resize}
            shouldUseLQIP={true}
            isSEOBot={seo}
            fluid
          />
        ))}
      </div>
    </div>
  )
}
